import React, { useState } from 'react';
import './Accordion.css';

const Accordion = ({ 
  title, 
  children, 
  isOpen = false, 
  onToggle,
  className = '',
  headerActions = null,
  disabled = false
}) => {
  const [internalOpen, setInternalOpen] = useState(isOpen);
  
  const isControlled = onToggle !== undefined;
  const open = isControlled ? isOpen : internalOpen;
  
  const handleToggle = () => {
    if (disabled) return;
    
    if (isControlled) {
      onToggle(!open);
    } else {
      setInternalOpen(!open);
    }
  };

  return (
    <div className={`accordion ${className} ${open ? 'open' : 'closed'} ${disabled ? 'disabled' : ''}`}>
      <div 
        className="accordion-header"
        onClick={handleToggle}
        role="button"
        tabIndex={disabled ? -1 : 0}
        onKeyDown={(e) => {
          if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
            e.preventDefault();
            handleToggle();
          }
        }}
      >
        <div className="accordion-title">
          <span className={`accordion-icon ${open ? 'rotated' : ''}`}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
          <span className="accordion-title-text">{title}</span>
        </div>
        
        {headerActions && (
          <div className="accordion-actions" onClick={(e) => e.stopPropagation()}>
            {headerActions}
          </div>
        )}
      </div>
      
      <div className={`accordion-content ${open ? 'expanded' : 'collapsed'}`}>
        <div className="accordion-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
